// extracted by mini-css-extract-plugin
export default {"editNickname":"editNickName_editNickname__MhFpL","usernameInput":"editNickName_usernameInput__uPPg8","buttonBox":"editNickName_buttonBox__wKHuI"};